export default __webpack_public_path__ + "static/media/search.829734fe.svg";